import type { FunctionComponent, ReactElement } from 'react';
import { useEffect } from 'react';

import { useCoreDispatch } from '../../../store/CoreStore';
import { chatActions } from '../../../store/slices/chat/slice';
import { ChatType } from '../../../store/slices/chat/types';
import { headerActions } from '../../../store/slices/header/slice';
import { useIsLargerThanWide } from '../../../styles/hooks/media';

import { NavPageBetLimitsConnected } from './betLimits/NavPageBetLimitsConnected';
import { NavPageChatConnected } from './chat/NavPageChatConnected';
import { NavPageSupportConnected } from './chat/NavPageSupportConnected';
import { NavPageHelpConnected } from './help/NavPageHelpConnected';
import { NavPageHistoryConnected } from './history/NavPageHistoryConnected';
import { useDelayedRouteByLevel } from './hooks';
import { NavQuickGuideConnected } from './quickGuide/NavQuickGuideConnected';
import { NavPageSettingsConnected } from './settings/NavPageSettingsConnected';

export enum NavPages {
  HOME = 'home', // This is the root drawer page
  CHAT = 'CHAT',
  SUPPORT = 'SUPPORT',
  SETTINGS = 'SETTINGS',
  HISTORY = 'HISTORY',
  BET_LIMITS = 'BET_LIMITS',
  HELP = 'HELP',
  QUICK_GUIDE = 'QUICK_GUIDE',
}

export const NavPagesConnected: FunctionComponent = (): ReactElement | null => {
  const dispatch = useCoreDispatch();
  const isWide = useIsLargerThanWide();
  const delayedRouteByLevel = useDelayedRouteByLevel();

  useEffect(() => {
    dispatch(headerActions.setNavForcedExpanded(delayedRouteByLevel === NavPages.QUICK_GUIDE));
    if (!isWide) {
      switch (delayedRouteByLevel) {
        case NavPages.CHAT:
          dispatch(chatActions.setOpenedChatType(ChatType.GameChat));
          break;
        case NavPages.SUPPORT:
          dispatch(chatActions.setOpenedChatType(ChatType.SupportChat));
          break;
        default:
          dispatch(chatActions.setOpenedChatType(null));
      }
    }
  }, [dispatch, delayedRouteByLevel, isWide]);

  useEffect(() => {
    if (isWide) {
      dispatch(headerActions.setNavRoute([]));
    }
  }, [isWide, dispatch]);

  switch (delayedRouteByLevel) {
    case NavPages.CHAT:
      return <NavPageChatConnected />;
    case NavPages.SUPPORT:
      return <NavPageSupportConnected />;
    case NavPages.SETTINGS:
      return <NavPageSettingsConnected />;
    case NavPages.HISTORY:
      return <NavPageHistoryConnected />;
    case NavPages.BET_LIMITS:
      return <NavPageBetLimitsConnected />;
    case NavPages.HELP:
      return <NavPageHelpConnected />;
    case NavPages.QUICK_GUIDE:
      return <NavQuickGuideConnected />;
    default:
      return null;
  }
};
